import Modal from "react-bootstrap/Modal";
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import "../../Style/__button.scss";
import "./LongTermAssetsModal.scss";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AddElementsButton } from "../../Components/AddElementsButton";

function InsertLongTermAsset(props) {
  const headers = authHeader();
  const email = LoginUserDetailed();
  const isEditMode = props.mode === "edit";

  const [accountID, setAccountID] = useState(null);
  const [AccName, setAccName] = useState("");
  const [ledgerID, setLedgerID] = useState("");
  const [ledgerName, setLedgerName] = useState("");
  const [comment, setComment] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [ledger, setLedger] = useState([]);
  const [filteredLedgers, setFilteredLedgers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [accountNameError, setAccountNameError] = useState("");
  const [ledgerError, setLedgerError] = useState("");

  const initialSnapshotRef = useRef(null);
  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const resetForm = () => {
    setAccountID(null);
    setAccName("");
    setLedgerID("");
    setLedgerName("");
    setComment("");
    setIsActive(true);
    setSearchTerm("");
    setAccountNameError("");
    setLedgerError("");
    setIsSubmitting(false);
    initialSnapshotRef.current = null;
    setShowConfirmClose(false);
  };

  const setFormFromAsset = (asset) => {
    setAccountID(asset?.AccountID ?? null);
    setAccName(asset?.AccountName ?? "");
    setLedgerID(asset?.LedgerID ?? "");
    setLedgerName(asset?.LedgerNameEN ?? "");
    setComment(asset?.Comment ?? "");
    setIsActive(typeof asset?.IsActive === "boolean" ? asset.IsActive : true);
    setSearchTerm("");
    setAccountNameError("");
    setLedgerError("");
    setIsSubmitting(false);
    initialSnapshotRef.current = {
      accName: asset?.AccountName ?? "",
      ledgerID: asset?.LedgerID ?? "",
      comment: asset?.Comment ?? "",
      isActive: typeof asset?.IsActive === "boolean" ? asset.IsActive : true,
    };
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "ledger/LongTermAssetsCategory", { headers })
      .then((response) => {
        setLedger(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (!props.show) return;
    if (isEditMode) {
      if (!props.initialData) return;
      setFormFromAsset(props.initialData);
      return;
    }
    resetForm();
  }, [props.show, props.initialData, isEditMode]);

  useEffect(() => {
    setFilteredLedgers(
      ledger.filter((data) =>
        data.LedgerNameEN.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, ledger]);

  const handleInputChange = (newValue) => {
    setSearchTerm(newValue.replace(/\W/g, ""));
  };

  const handleFilterLedger = (selectedOption) => {
    if (selectedOption && selectedOption.LedgerID) {
      setLedgerID(selectedOption.LedgerID);
      setLedgerName(selectedOption.label);
      setLedgerError("");
    } else {
      setLedgerID("");
      setLedgerName("");
    }
  };

  const selectedLedgerOption = useMemo(() => {
    if (!ledgerID) return null;
    const matched = ledger.find(
      (entry) => String(entry.LedgerID) === String(ledgerID)
    );
    if (matched) {
      return {
        label: matched.LedgerNameEN,
        value: matched.LedgerID,
        LedgerID: matched.LedgerID,
      };
    }
    if (ledgerName) {
      return { label: ledgerName, value: ledgerID, LedgerID: ledgerID };
    }
    return null;
  }, [ledger, ledgerID, ledgerName]);

  const isDirty = useMemo(() => {
    if (!isEditMode) {
      return AccName.trim() !== "" || ledgerID !== "" || comment !== "";
    }
    const snapshot = initialSnapshotRef.current;
    if (!snapshot) return false;
    return (
      AccName !== snapshot.accName ||
      ledgerID !== snapshot.ledgerID ||
      comment !== snapshot.comment ||
      isActive !== snapshot.isActive
    );
  }, [isEditMode, AccName, ledgerID, comment, isActive]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    const trimmedName = AccName.trim();
    const trimmedComment = comment.trim();
    let hasError = false;
    if (trimmedName === "") {
      setAccountNameError("Plotësoni emrin e asetit");
      hasError = true;
    } else {
      setAccountNameError("");
    }
    if (ledgerID == null || ledgerID === "") {
      setLedgerError("Plotësoni fushën e llogarisë kontabël");
      hasError = true;
    } else {
      setLedgerError("");
    }
    if (hasError) return;
    setIsSubmitting(true);
    const insertPayload = {
      AccountName: trimmedName,
      LedgerID: ledgerID,
      Comment: trimmedComment,
      CreatedByUser: email,
      IsActive: true,
    };
    const updatePayload = {
      AccountID: accountID,
      AccountName: trimmedName,
      LedgerID: ledgerID,
      Comment: trimmedComment,
      ModifiedByUser: email,
      IsActive: isActive,
    };
    const submitRequest = isEditMode
      ? axios.put(ApiLink.API_URL + "Accounts/editExpence", updatePayload, { headers })
      : axios.post(ApiLink.API_URL + "Accounts/createExpence", insertPayload, { headers });
    submitRequest
      .then(() => {
        handleSuccess(
          isEditMode ? "Aseti u përditësua me sukses" : "Aseti u shtua me sukses"
        );
        resetForm();
        props.onHide();
        if (props.fetchData) props.fetchData();
      })
      .catch((error) => {
        console.error(error);
        errorAlert("Gabim gjatë ruajtjes së të dhënave.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const doClose = () => {
    if (isSubmitting) return;
    props.onHide();
    resetForm();
  };

  const handleClose = () => {
    if (isSubmitting) return;
    if (isDirty) {
      setShowConfirmClose(true);
      return;
    }
    doClose();
  };

  return (
    <>
      <Modal
        {...props}
        onHide={handleClose}
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
        size="lg"
        dialogClassName="lta-modal-dialog"
        contentClassName="lta-modal-content"
        aria-labelledby="lta-modal-title"
        centered
      >
        <Modal.Header className="ltam__header">
          <div className="ltam__header-content">
            <Modal.Title id="lta-modal-title" className="ltam__title">
              {isEditMode ? "Përditëso Asetin" : "Krijo Aset të ri"}
            </Modal.Title>
            <p className="ltam__subtitle">
              {isEditMode
                ? "Ndrysho të dhënat e asetit dhe ruaji për përditësim në sistem."
                : "Plotësoni të dhënat e asetit dhe ruani për ta shtuar në sistem."}
            </p>
            <div className="ltam__meta">
              <span className="ltam__meta-pill">Fushat me * janë obligative</span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="ltam__body">
          <form onSubmit={handleSubmit} className="ltam__form">
            <section className="ltam__section">
              <h6 className="ltam__section-title">Informata Kryesore</h6>
              <div className="ltam__grid ltam__grid-2">
                <div className="ltam__field ltam__field-full">
                  <TextField
                    fullWidth
                    required
                    id="AccountName"
                    label="Emri i Asetit *"
                    variant="outlined"
                    type="text"
                    name="AccountName"
                    value={AccName}
                    onChange={(event) => {
                      setAccName(event.target.value);
                      if (accountNameError) setAccountNameError("");
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="ltam__error">
                    {accountNameError && `${accountNameError}`}
                  </span>
                </div>

                <div className="ltam__field ltam__field-full">
                  <label className="ltam__select-label">
                    Përzgjedh Llogarinë Kontabël *
                  </label>
                  <Select
                    inputId="LedgerID"
                    classNamePrefix="ltam-select"
                    value={selectedLedgerOption}
                    options={filteredLedgers.map((data) => ({
                      label: data.LedgerNameEN,
                      value: data.LedgerID,
                      LedgerID: data.LedgerID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterLedger}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="ltam__error">
                    {ledgerError && `${ledgerError}`}
                  </span>
                </div>
              </div>
            </section>

            <section className="ltam__section">
              <h6 className="ltam__section-title">Koment</h6>
              <div className="ltam__grid ltam__grid-2">
                <div className="ltam__field ltam__field-full">
                  <textarea
                    rows={3}
                    className="ltam__notes"
                    id="Comment"
                    placeholder="Komenti"
                    name="Comment"
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                    autoComplete="off"
                  />
                </div>
                {isEditMode && (
                  <div className="ltam__field ltam__field-full">
                    <label className="ltam__active-toggle">
                      <input
                        type="checkbox"
                        checked={Boolean(isActive)}
                        onChange={(event) => setIsActive(event.target.checked)}
                        className="ltam__active-checkbox"
                        disabled={isSubmitting}
                      />
                      <span className="ltam__active-copy">
                        <span className="ltam__active-title">Statusi i asetit</span>
                        <span className="ltam__active-description">
                          {isActive ? "Aseti është aktiv në sistem" : "Aseti është joaktiv në sistem"}
                        </span>
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </section>

            <div className="ltam__footer">
              <Button
                type="submit"
                variant="contained"
                className="ltam__save-btn"
                disabled={isSubmitting || (isEditMode && !isDirty)}
              >
                {isSubmitting
                  ? "Duke ruajtur..."
                  : isEditMode
                  ? "Përditëso & Mbyll"
                  : "Ruaj & Mbyll"}
              </Button>
              <Button
                variant="outlined"
                className="ltam__close-btn"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Mbyll
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Dialog
        open={showConfirmClose}
        onClose={() => setShowConfirmClose(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat e ndryshuara do të humbin. A
          jeni të sigurt?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmClose(false)} variant="outlined">
            Kthehu
          </Button>
          <Button onClick={doClose} variant="contained" color="error">
            Po, mbyll pa ruajtur
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function LongTermAssetsModal(props) {
  const [internalModalShow, setInternalModalShow] = React.useState(false);
  const isControlled = typeof props.show === "boolean";
  const modalShow = isControlled ? props.show : internalModalShow;

  const openModal = () => {
    if (isControlled) return;
    setInternalModalShow(true);
  };

  const closeModal = () => {
    if (isControlled) {
      if (props.onHide) props.onHide();
      return;
    }
    setInternalModalShow(false);
  };

  const handleRefreshData = () => {
    if (props.fetchData) props.fetchData();
  };

  return (
    <>
      {!isControlled &&
        (props.type === "text" ? (
          <AddElementsButton
            text="Krijo Aset"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-68"
          />
        ) : props.type === "insert" ? (
          <AddElementsButton
            text="Krijo Aset"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-15"
          />
        ) : (
          <AddBoxIcon
            style={{ height: "30px", width: "30px", color: "black" }}
            onClick={openModal}
          />
        ))}

      <InsertLongTermAsset
        show={modalShow}
        onHide={closeModal}
        fetchData={handleRefreshData}
        mode={props.mode}
        initialData={props.initialData}
      />
    </>
  );
}
